var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { ref: "modal", staticClass: "modal fade" }, [
    _c(
      "div",
      {
        staticClass: "modal-dialog modal-dialog-scrollable",
        attrs: { role: "document" }
      },
      [
        _vm.request
          ? _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v(_vm._s(_vm.$t("kanban.approval.approveModal.title")))
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.dismiss.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("×")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c(
                  "ul",
                  { staticClass: "list-group" },
                  _vm._l(_vm.cards, function(card) {
                    return _c(
                      "li",
                      {
                        staticClass: "list-group-item c-pointer",
                        on: {
                          click: function($event) {
                            return _vm.openCard(card)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(card.name) + "\n          "
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("kanban.approval.approveModal.enterName")) +
                    "\n        "
                ),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.signature,
                      expression: "signature"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.signature },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.signature = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    on: { click: _vm.dismiss }
                  },
                  [_vm._v(_vm._s(_vm.$t("btnCancel")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { disabled: !_vm.canSave || _vm.saving },
                    on: { click: _vm.save }
                  },
                  [
                    _vm.saving
                      ? _c("Spinner", { attrs: { small: true } })
                      : _vm._e(),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("kanban.approval.approveModal.approve")) +
                        "\n        "
                    )
                  ],
                  1
                )
              ])
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }